import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initMetaPixel, trackEvent, isPixelReady } from '@/lib/metaPixel';

/**
 * Mount once at the top of the router tree. Fires a fresh `PageView` on
 * every SPA route change and (re-)initializes the pixel if the user has
 * granted consent since last check.
 */
export default function MetaPixelRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Try to initialize on every route change — no-op if already booted,
    // no consent, or PIXEL_ID missing.
    initMetaPixel();
    if (isPixelReady()) {
      trackEvent('PageView');
    }
  }, [location.pathname, location.search]);

  return null;
}
